import { MenuItem, SidebarMenuItems } from './menu-items';
import { Component } from '@angular/core';

@Component({
  selector: 'cosmos-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  public readonly _items: MenuItem[] = SidebarMenuItems;
}
